import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Http, HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {AbsAccordionComponent} from './abs-accordion.component';
import {AbsAccordianGroupComponent} from './abs-accordion-group.component';

@NgModule({
  imports: [CommonModule, FormsModule, HttpModule],
  declarations: [AbsAccordionComponent, AbsAccordianGroupComponent],
  exports: [AbsAccordionComponent, AbsAccordianGroupComponent]
})
export class AbsExpandCollapseModule { }
